
export enum AppEventName {
  SessionExpiration = 'SessionExpiration',
  NewAccessToken = 'NewAccessToken',
  LogoutRequest = 'LogoutRequest',
  LeaveImpersonation = 'LeaveImpersonation',
  LoggedIn = 'LoggedIn',
  LoggedOut = 'LoggedOut',
  NewUserSession = 'NewUserSession',
  NavigationData = 'NavigationData',
  TranslationDownloading = 'TranslationDownloading',
  TranslationDownloaded = 'TranslationDownloaded',
  AddAppStatus = 'AddAppStatus',
  RemoveAppStatus = 'RemoveAppStatus',
  AddProgressTrackableItem = 'AddProgressTrackableItem',
  RemoveProgressTrackableItem = 'RemoveProgressTrackableItem',
  AlertNotification = 'AlertNotification',
  AlertSelection = 'AlertSelection',
  NotificationListToggled = 'NotificationListToggled',
}
